import { cva, type VariantProps } from 'class-variance-authority';
import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../cn';

const inputStyles = cva(
  [
    'w-full bg-surface text-fg-primary placeholder:text-fg-tertiary',
    'border border-border-default rounded-sm',
    'transition-colors duration-fast ease-in-out-cubic',
    'focus-visible:outline-none focus-visible:border-accent focus-visible:ring-2 focus-visible:ring-accent/30',
    'disabled:opacity-50 disabled:cursor-not-allowed',
    'aria-[invalid=true]:border-negative aria-[invalid=true]:focus-visible:ring-negative/30',
  ],
  {
    variants: {
      inputSize: {
        sm: 'h-8 px-3 text-sm',
        md: 'h-10 px-3 text-base',
        lg: 'h-12 px-4 text-lg',
      },
    },
    defaultVariants: {
      inputSize: 'md',
    },
  }
);

interface InputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'>, VariantProps<typeof inputStyles> {}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, inputSize, ...props }, ref) => (
    <input ref={ref} className={cn(inputStyles({ inputSize }), className)} {...props} />
  )
);
Input.displayName = 'Input';
